module.exports = __webpack_public_path__ + "img/file-circle-xmark-solid-full.9e33b4e7.svg";